import DataroomsList from './DataroomsList';

export default DataroomsList;
